import { createContext } from 'react'

export const NavigationTileContext = createContext(false)
